import BaseModel from '@/lib/models/base-model';
import defineProperty from '@/lib/helpers/define-property';
import modelComponentStore from '@/lib/services/model-component-store';

class BaseFormModel extends BaseModel {
  constructor(component, uiProps) {
    super(component);

    modelComponentStore.addComponent(this, component);

    defineProperty(this, 'uiProps');
    this.uiProps = uiProps;

    defineProperty(this, 'transactionalBlockers');
    this.transactionalBlockers = [];

    defineProperty(this, 'loaders');
    this.loaders = [];

    // TODO: Remove ASAP
    this.$rendererComponent = null;
  }

  addTransactionalBlocker(reason) {
    if (this.transactionalBlockers.indexOf(reason) === -1) {
      this.transactionalBlockers = [...this.transactionalBlockers, reason];
    }
  }

  releaseTransactionalBlocker(reason) {
    this.transactionalBlockers = this.transactionalBlockers.filter(r => r !== reason);
  }

  addLoader(reason) {
    if (this.loaders.indexOf(reason) === -1) {
      this.loaders = [...this.loaders, reason];
    }
  }

  releaseLoader(reason) {
    this.loaders = this.loaders.filter(r => r !== reason);
  }

  get component() {
    return modelComponentStore.componentForModel(this);
  }
}

export default BaseFormModel;
